import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=ad0f4478&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports